module.exports = __webpack_public_path__ + "static/media/card.034181d8.svg";